export const SKIP_SCALAR = {};
/**
 * Target type differentiators
 */
export var TargetType;
(function (TargetType) {
    TargetType["ARRAY"] = "ARRAY";
    TargetType["OBJECT"] = "OBJECT";
    TargetType["SCALAR"] = "SCALAR";
    TargetType["TEMPLATE_OBJECT"] = "TEMPLATE_OBJECT";
    TargetType["TEMPLATE_OBJECT_PROPERTIES"] = "TEMPLATE_OBJECT_PROPERTIES";
    TargetType["TEMPLATE_OBJECT_ELEMENTS"] = "TEMPLATE_OBJECT_ELEMENTS";
})(TargetType || (TargetType = {}));
